import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pages',
    template: `<app-header></app-header>
  <div class="row">
    <div class="col-md-2 ">
      <app-side-bar></app-side-bar>
    </div>
    <div class="col-md-10 col-12">
      <router-outlet></router-outlet>
    </div>
  </div>`,
})
export class PagesComponent implements OnInit {
    constructor() { }
    ngOnInit() { }
}
